import React from "react"; // Import React for JSX

// A simple placeholder icon if no icon is provided - can be replaced by a more specific one from an icon library
const DefaultIcon = () => (
  <svg
    className="h-5 w-5 text-muted-foreground"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

interface PreviewCardProps {
  title: string;
  category: string;
  icon?: React.ReactNode;
}

export const PreviewCard = ({ title, category, icon }: PreviewCardProps) => {
  return (
    <div className="mt-2 p-3 border border-border rounded-md bg-background/70 hover:shadow-md transition-shadow cursor-pointer w-full">
      <div className="flex items-center gap-2">
        {icon || <DefaultIcon />}
        <div>
          <p className="text-sm font-semibold text-primary">{title}</p>
          <p className="text-xs text-muted-foreground">{category}</p>
        </div>
      </div>
    </div>
  );
};
